import { useInfiniteQuery } from 'react-query';
import getReportsHistory, { Variables } from 'data/requests/getReportsHistory';
import { ReportHistory } from 'model/report';

const useReportsHistory = () => {
  const {
    data,
    isFetching,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    refetch,
  } = useInfiniteQuery<ReportHistory>(
    ['ReportHistory'],
    ({ pageParam }: Variables) =>
      getReportsHistory({
        pageParam,
      }),
    {
      getNextPageParam: (lastPage) => lastPage.cursor,
    },
  );

  const reports = (data?.pages || []).flatMap(
    (request: ReportHistory) => request.reports,
  );

  return {
    reports,
    isFetchingNextPage,
    isFetching,
    hasNextPage,
    fetchNextPage,
    refetch,
  };
};

export default useReportsHistory;
